import { Component, OnInit } from '@angular/core';
import { ModalController } from '@ionic/angular';
import { AscentFilterType, BoulderFilter } from '../../model/boulder-filter';
import { BBStorage } from '../../utils/bb-storage';
import { WallService } from '../../services/wall.service';
import { Wall } from '../../model/wall';
import { BoulderService } from '../../services/boulder.service';
import { GuestService } from '../../services/guest-service';
import { GradeService } from 'src/services/grade.service';
import { firstValueFrom } from 'rxjs';
import { Boulder } from 'src/model/boulder';

@Component({
  selector: 'app-boulder-filter',
  templateUrl: './boulder-filter.component.html',
  styleUrls: ['./boulder-filter.component.scss'],
})
export class BoulderFilterComponent implements OnInit {

  availableWalls: Wall[];
  allBoulders: Boulder[];

  walls = [];
  sortBy;
  ascentFilter: AscentFilterType;
  gradeRange;
  numberOfBouldersPassingFilter = null;
  onlyCampusBoulders = false;
  noCampusBoulders = false;
  maxGrade = 21;

  private numBouldersByWallId: Map<string, number>;

  constructor(
    private gradeService: GradeService,
    public guestService: GuestService,
    private boulderService: BoulderService,
    private wallService: WallService,
    private bbStorage: BBStorage,
    private modalCtrl: ModalController) {
  }

  ngOnInit() {
    this.load();
  }

  private async load() {
    const filter = this.bbStorage.boulderFilter;
    this.sortBy = this.bbStorage.boulderListSortType;
    this.maxGrade = this.gradeService.getCurrentGradeSystem().maxGradeInteger();
    this.gradeRange = { lower: filter.gradeMin ?? 0, upper: filter.gradeMax ?? this.maxGrade };
    this.ascentFilter = filter.ascentFilterType;
    this.walls = filter.wallNames;
    this.availableWalls = await firstValueFrom(this.wallService.loadWalls$());
    this.numBouldersByWallId = new Map<string, number>();
    this.allBoulders = await firstValueFrom(this.boulderService.getBoulders$());
    this.noCampusBoulders = filter.noCampusBoulders;
    this.onlyCampusBoulders = filter.onlyCampusBoulders;
    this.allBoulders.forEach(b => {
      const numBoulders = this.numBouldersByWallId.get(b.wallId) ?? 0;
      this.numBouldersByWallId.set(b.wallId, numBoulders + 1);
    });
    this.availableWalls = this.availableWalls.sort((a, b) => {
      const countA = this.numBouldersByWallId.get(a.wallId);
      const countB = this.numBouldersByWallId.get(b.wallId);
      if (countA && countB) {
        return countA > countB ? -1 : 1;
      } else if (countA) {
        return -1;
      } else if (countB) {
        return 1;
      } else {
        return a.wallName > b.wallName ? 1 : -1;
      }
    })
    this.computeNumberOfBoulders();
  }
  async dismiss() {
    await this.modalCtrl.dismiss();
  }

  async reset() {
    this.bbStorage.boulderListSortType = 'date';
    await this.saveAndClose(BoulderFilter.empty());
  }

  async apply() {
    this.bbStorage.boulderListSortType = this.sortBy;
    await this.saveAndClose(this.createFilter());
  }

  private createFilter() {
    return new BoulderFilter(this.ascentFilter, this.gradeRange.lower === 0 ? null : this.gradeRange.lower, this.gradeRange.upper === this.maxGrade ? null : this.gradeRange.upper, this.walls, this.onlyCampusBoulders, this.noCampusBoulders);
  }

  private async saveAndClose(filter: BoulderFilter) {
    this.bbStorage.boulderFilter = filter;
    await this.modalCtrl.dismiss({ changed: true });
  }

  toggleNoCampusButton($event) {
    this.onlyCampusBoulders = !$event.detail.value;
    this.computeNumberOfBoulders();
  }

  toggleOnlyCampusButton($event) {
    this.noCampusBoulders = !$event.detail.value;
    this.computeNumberOfBoulders();
  }

  computeNumberOfBoulders($event = null) {
    if ($event?.detail?.value?.lower && $event?.detail?.value?.upper) {
      this.gradeRange = $event.detail.value;
    }
    this.numberOfBouldersPassingFilter = null;
    const filter = this.createFilter();
    if (!this.allBoulders) {
      this.numberOfBouldersPassingFilter = 0;
    } else if (BoulderFilter.isEmpty(filter)) {
      this.numberOfBouldersPassingFilter = this.allBoulders.length;
    } else {
      this.numberOfBouldersPassingFilter = this.allBoulders.filter(b => BoulderFilter.passesFilter(b, filter)).length;
    }
  }
}
